// Resize and compress an image File to a base64 JPEG data URL.
// Auto-retries at lower quality / smaller size if the encoded result is too big.
// Throws explicit errors so the UI can show useful messages (HEIC fail, too big, etc).
const MAX_BASE64_LEN = 380000; // server limit is 400000 — leave headroom

function fileToImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = () =>
        reject(
          new Error(
            "Formato no soportado por tu navegador (probablemente HEIC). En iPhone: ve a Ajustes → Cámara → Formatos → Más compatible, o usa una captura de pantalla."
          )
        );
      img.onload = () => resolve(img);
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}

function encode(img, maxSize, quality) {
  const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
  const w = Math.max(1, Math.round(img.width * scale));
  const h = Math.max(1, Math.round(img.height * scale));
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(img, 0, 0, w, h);
  const dataUrl = canvas.toDataURL("image/jpeg", quality);
  if (!dataUrl || dataUrl === "data:," || !dataUrl.startsWith("data:image/jpeg")) {
    throw new Error("La imagen no se pudo procesar. Intenta con otra foto (JPG o PNG).");
  }
  return dataUrl;
}

export async function resizeImageToBase64(file, maxSize = 400, quality = 0.85) {
  if (!file) return null;
  // Friendly type check (allow heic/heif but warn — most browsers can't draw them)
  if (file.type && !file.type.startsWith("image/")) {
    throw new Error("El archivo no es una imagen");
  }

  const img = await fileToImage(file);

  // Try progressively smaller / lower quality until it fits comfortably
  const attempts = [
    [maxSize, quality],
    [maxSize, 0.7],
    [350, 0.7],
    [300, 0.65],
    [260, 0.6],
  ];
  let last = null;
  for (const [s, q] of attempts) {
    const out = encode(img, s, q);
    last = out;
    if (out.length <= MAX_BASE64_LEN) return out;
  }
  // If we got here, give up but still return a smaller variant if available
  if (last && last.length <= 420000) return last;
  throw new Error("La foto es demasiado grande incluso después de comprimirla. Intenta con otra foto.");
}
